// src/data/hederaFees.js
// Hedera Network API Fee Data
// Prices as of November 2025

export const hederaFeeData = {
  services: [
    {
      id: 'cryptocurrency',
      name: 'Cryptocurrency Service',
      description: 'HBAR transfers and account management',
      iconKey: 'cryptocurrency',
      apis: [
        {
          id: 'cryptoCreate',
          name: 'CryptoCreate',
          description: 'Creates a new account.',
          estimateUSD: 0.05
        },
        {
          id: 'cryptoAccountAutoRenew',
          name: 'CryptoAccountAutoRenew',
          description: 'Extends account lifetime for auto-renewal accounts.',
          estimateUSD: 0.00022
        },
        {
          id: 'cryptoDeleteAllowance',
          name: 'CryptoDeleteAllowance',
          description: 'Deletes an token allowance.',
          estimateUSD: 0.05
        },
        {
          id: 'cryptoApproveAllowance',
          name: 'CryptoApproveAllowance',
          description: 'Approves an token spending allowance.',
          estimateUSD: 0.05
        },
        {
          id: 'cryptoAddLiveHash',
          name: 'CryptoAddLiveHash',
          description: 'Adds a livehash to an account.',
          estimateUSD: 0.10
        },
        {
          id: 'cryptoDeleteLiveHash',
          name: 'CryptoDeleteLiveHash',
          description: 'Deletes a livehash from an account.',
          estimateUSD: 0.005
        },
        {
          id: 'cryptoGetLiveHash',
          name: 'CryptoGetLiveHash',
          description: 'Retrieves the livehash associated with an account.',
          estimateUSD: 0.0001
        },
        {
          id: 'cryptoUpdate',
          name: 'CryptoUpdate',
          description: 'Updates account properties such as keys or memo.',
          estimateUSD: 0.00022
        },
        {
          id: 'cryptoTransfer',
          name: 'CryptoTransfer',
          description: 'Transfers tokens between accounts.',
          estimateUSD: 0.0001
        },
        {
          id: 'cryptoTransferCustomFees',
          name: 'CryptoTransfer (custom fees)',
          description: 'Transfers tokens under a custom fee schedule.',
          estimateUSD: 0.002
        },
        {
          id: 'cryptoDelete',
          name: 'CryptoDelete',
          description: 'Deletes a cryptocurrency account.',
          estimateUSD: 0.005
        },
        {
          id: 'cryptoGetAccountRecords',
          name: 'CryptoGetAccountRecords',
          description: 'Retrieves account transaction records.',
          estimateUSD: 0.0001
        },
        {
          id: 'cryptoGetAccountBalance',
          name: 'CryptoGetAccountBalance',
          description: 'Gets the account balance.',
          estimateUSD: 0.00
        },
        {
          id: 'cryptoGetInfo',
          name: 'CryptoGetInfo',
          description: 'Gets metadata about an account.',
          estimateUSD: 0.0001
        },
        {
          id: 'cryptoGetStakers',
          name: 'CryptoGetStakers',
          description: 'Retrieves staking information for an account.',
          estimateUSD: 0.0001
        }
      ]
    },
    {
      id: 'consensus',
      name: 'Consensus Service',
      description: 'HCS - Submit and retrieve messages',
      iconKey: 'consensus',
      apis: [
        {
          id: 'consensusCreateTopic',
          name: 'ConsensusCreateTopic',
          description: 'Creates a new consensus topic.',
          estimateUSD: 0.01
        },
        {
          id: 'consensusCreateTopicCustomFees',
          name: 'ConsensusCreateTopic (with custom fees)',
          description: 'Creates a topic with a custom fee schedule.',
          estimateUSD: 2.00
        },
        {
          id: 'consensusUpdateTopic',
          name: 'ConsensusUpdateTopic',
          description: 'Updates topic properties.',
          estimateUSD: 0.00022
        },
        {
          id: 'consensusDeleteTopic',
          name: 'ConsensusDeleteTopic',
          description: 'Deletes a topic.',
          estimateUSD: 0.005
        },
        {
          id: 'consensusSubmitMessage',
          name: 'ConsensusSubmitMessage',
          description: 'Submits a message to a topic.',
          estimateUSD: 0.0008
        },
        {
          id: 'consensusSubmitMessageCustomFees',
          name: 'ConsensusSubmitMessage (with custom fees)',
          description: 'Submits a message with custom fees.',
          estimateUSD: 0.05
        },
        {
          id: 'consensusGetTopicInfo',
          name: 'ConsensusGetTopicInfo',
          description: 'Retrieves topic metadata.',
          estimateUSD: 0.0001
        }
      ]
    },
    {
      id: 'token',
      name: 'Token Service',
      description: 'HTS - Create and manage tokens',
      iconKey: 'token',
      apis: [
        {
          id: 'tokenAirdrop',
          name: 'TokenAirdrop (no prior association with token)',
          description: 'Airdrops a token to an unassociated account.',
          estimateUSD: 0.10
        },
        {
          id: 'tokenAssociate',
          name: 'TokenAssociate',
          description: 'Associates a token with an account.',
          estimateUSD: 0.05
        },
        {
          id: 'tokenBurn',
          name: 'TokenBurn',
          description: 'Burns tokens to reduce supply.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenCancelAirdrop',
          name: 'TokenCancelAirdrop',
          description: 'Cancels a pending airdrop.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenClaimAirdrop',
          name: 'TokenClaimAirdrop',
          description: 'Claims a pending airdrop.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenCreate',
          name: 'TokenCreate',
          description: 'Creates a new token.',
          estimateUSD: 1.00
        },
        {
          id: 'tokenCreateCustomFees',
          name: 'TokenCreate (custom fees)',
          description: 'Creates a token with custom fees.',
          estimateUSD: 2.00
        },
        {
          id: 'tokenDelete',
          name: 'TokenDelete',
          description: 'Deletes a token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenDissociate',
          name: 'TokenDissociate',
          description: 'Removes token association from an account.',
          estimateUSD: 0.05
        },
        {
          id: 'tokenFeeScheduleUpdate',
          name: 'TokenFeeScheduleUpdate',
          description: "Updates the token's fee schedule.",
          estimateUSD: 0.001
        },
        {
          id: 'tokenFreeze',
          name: 'TokenFreeze',
          description: 'Freezes an account for the token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenGetInfo',
          name: 'TokenGetInfo',
          description: 'Retrieves token metadata.',
          estimateUSD: 0.0001
        },
        {
          id: 'tokenGetAccountNftInfos',
          name: 'TokenGetAccountNftInfos',
          description: 'Retrieves NFTs owned by an account.',
          estimateUSD: 0.0001
        },
        {
          id: 'tokenGetNftInfo',
          name: 'TokenGetNftInfo',
          description: 'Retrieves metadata for a specific NFT.',
          estimateUSD: 0.0001
        },
        {
          id: 'tokenGetNftInfos',
          name: 'TokenGetNftInfos',
          description: 'Retrieves metadata for all NFTs of a token.',
          estimateUSD: 0.0001
        },
        {
          id: 'tokenGrantKyc',
          name: 'TokenGrantKyc',
          description: 'Grants KYC permission for a token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenMintFungible',
          name: 'TokenMint (fungible)',
          description: 'Mints fungible tokens.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenMintNonFungible',
          name: 'TokenMint (non-fungible)',
          description: 'Mints a non‑fungible token.',
          estimateUSD: 0.02
        },
        {
          id: 'tokenPause',
          name: 'TokenPause',
          description: 'Pauses the token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenReject',
          name: 'TokenReject',
          description: 'Rejects a received token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenRevokeKyc',
          name: 'TokenRevokeKyc',
          description: 'Revokes KYC permission.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenTransfer',
          name: 'TokenTransfer',
          description: 'Transfers tokens or NFTs.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenUnfreeze',
          name: 'TokenUnfreeze',
          description: 'Unfreezes an account for a token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenUpdate',
          name: 'TokenUpdate',
          description: "Updates a token's properties.",
          estimateUSD: 0.001
        },
        {
          id: 'tokenUnpause',
          name: 'TokenUnpause',
          description: 'Unpauses the token.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenUpdateNftsSingle',
          name: 'TokenUpdateNfts (updates metadata of 1 NFT)',
          description: 'Updates metadata for a NFT.',
          estimateUSD: 0.001
        },
        {
          id: 'tokenWipe',
          name: 'TokenWipe',
          description: 'Wipes tokens or NFTs from an account.',
          estimateUSD: 0.001
        }
      ]
    },
    {
      id: 'scheduleTransaction',
      name: 'Schedule Transaction',
      description: 'Schedule Transaction',
      iconKey: 'scheduleTransaction',
      apis: [
        {
          id: 'scheduleCreate',
          name: 'ScheduleCreate',
          description: 'Creates a scheduled transaction.',
          estimateUSD: 0.01
        },
        {
          id: 'scheduleSign',
          name: 'ScheduleSign',
          description: 'Signs a scheduled transaction.',
          estimateUSD: 0.001
        },
        {
          id: 'scheduleDelete',
          name: 'ScheduleDelete',
          description: 'Deletes a scheduled transaction.',
          estimateUSD: 0.001
        },
        {
          id: 'scheduleGetInfo',
          name: 'ScheduleGetInfo',
          description: 'Retrieves metadata for a scheduled transaction.',
          estimateUSD: 0.0001
        }
      ]
    },
    {
      id: 'fileService',
      name: 'File Service',
      description: 'Store and retrieve files',
      iconKey: 'fileService',
      apis: [
        {
          id: 'fileCreate',
          name: 'FileCreate',
          description: 'Creates a new file.',
          estimateUSD: 0.05
        },
        {
          id: 'fileUpdate',
          name: 'FileUpdate',
          description: 'Updates a file.',
          estimateUSD: 0.05
        },
        {
          id: 'fileDelete',
          name: 'FileDelete',
          description: 'Deletes a file.',
          estimateUSD: 0.007
        },
        {
          id: 'fileAppend',
          name: 'FileAppend',
          description: 'Appends data to a file.',
          estimateUSD: 0.05
        },
        {
          id: 'fileGetContents',
          name: 'FileGetContents',
          description: 'Gets the contents of a file.',
          estimateUSD: 0.0001
        },
        {
          id: 'fileGetInfo',
          name: 'FileGetInfo',
          description: 'Retrieves file metadata.',
          estimateUSD: 0.0001
        }
      ]
    },
    {
      id: 'smartContract',
      name: 'Smart Contract Service',
      description: 'Deploy and execute smart contracts',
      iconKey: 'smartContract',
      apis: [
        {
          id: 'contractCreate',
          name: 'ContractCreate',
          description: 'Deploys a smart contract.',
          estimateUSD: 1.00
        },
        {
          id: 'contractUpdate',
          name: 'ContractUpdate',
          description: 'Updates a contract.',
          estimateUSD: 0.026
        },
        {
          id: 'contractDelete',
          name: 'ContractDelete',
          description: 'Deletes a contract.',
          estimateUSD: 0.007
        },
        {
          id: 'contractCall',
          name: 'ContractCall',
          description: 'Calls a contract function.',
          estimateUSD: 0.00
        },
        {
          id: 'contractCallLocal',
          name: 'ContractCallLocal',
          description: 'Executes a local contract query.',
          estimateUSD: 0.001
        },
        {
          id: 'contractGetByteCode',
          name: 'ContractGetByteCode',
          description: 'Retrieves contract bytecode.',
          estimateUSD: 0.05
        },
        {
          id: 'contractGetInfo',
          name: 'ContractGetInfo',
          description: 'Retrieves contract metadata.',
          estimateUSD: 0.0001
        },
        {
          id: 'contractGetRecords',
          name: 'ContractGetRecords',
          description: 'Retrieves contract records.',
          estimateUSD: 0.0001
        },
        {
          id: 'contractAutoRenew',
          name: 'ContractAutoRenew',
          description: "Auto‑renews the contract's linked account.",
          estimateUSD: 0.026
        },
        {
          id: 'ethereumTransactionSuccess',
          name: 'EthereumTransaction (successful transactions)',
          description: 'Submits an EVM‑formatted transaction.',
          estimateUSD: 0.00
        },
        {
          id: 'ethereumTransactionFailed',
          name: 'EthereumTransaction (failed transactions)',
          description: 'Submits an EVM-formatted transaction that fails but still consumes gas.',
          estimateUSD: 0.0001
        },
        {
          id: 'getBySolidityId',
          name: 'GetBySolidityID',
          description: 'Resolves a Solidity‑style address.',
          estimateUSD: 0.0001
        }
      ]
    },
    {
      id: 'miscellaneous',
      name: 'Miscellaneous',
      description: 'Batch transactions, node operations, PRNG, and system utilities',
      iconKey: 'miscellaneous',
      apis: [
        {
          id: 'batchTransaction',
          name: 'BatchTransaction (HIP-551)',
          description: 'Executes a batch of transactions.',
          estimateUSD: 0.001
        },
        {
          id: 'getVersionInfo',
          name: 'GetVersionInfo',
          description: 'Retrieves network version metadata.',
          estimateUSD: 0.0001
        },
        {
          id: 'getByKey',
          name: 'GetByKey',
          description: 'Retrieves entities linked to a key.',
          estimateUSD: 0.0001
        },
        {
          id: 'nodeCreate',
          name: 'NodeCreate',
          description: 'Creates a network node.',
          estimateUSD: 0.001
        },
        {
          id: 'nodeDelete',
          name: 'NodeDelete',
          description: 'Deletes a network node.',
          estimateUSD: 0.001
        },
        {
          id: 'nodeUpdate',
          name: 'NodeUpdate',
          description: 'Updates a network node.',
          estimateUSD: 0.001
        },
        {
          id: 'prngTransaction',
          name: 'PrngTransaction',
          description: 'Requests a pseudo‑random number.',
          estimateUSD: 0.001
        },
        {
          id: 'systemDelete',
          name: 'SystemDelete',
          description: 'Deletes a system entity.',
          estimateUSD: 0.00
        },
        {
          id: 'systemUndelete',
          name: 'SystemUndelete',
          description: 'Restores a deleted system entity.',
          estimateUSD: 0.00
        },
        {
          id: 'transactionGetReceipt',
          name: 'TransactionGetReceipt',
          description: 'Retrieves a transaction receipt.',
          estimateUSD: 0.00
        },
        {
          id: 'transactionGetRecord',
          name: 'TransactionGetRecord',
          description: 'Retrieves a transaction record.',
          estimateUSD: 0.0001
        }
      ]
    }
  ],
  
  // Exchange rate (approximate)
  exchangeRate: {
    hbarToUSD: 0.12
  },
  
  // Metadata
  lastUpdated: '2026-01-07',
  disclaimer: {
    text: '*Hedera fee tool calculates fees required to process a transaction on the Hedera network, however, such calculations may not be 100% accurate and can change based on voting by Hedera Council.',
    link: {
      url: 'https://docs.hedera.com/hedera/networks/mainnet/fees',
      text: 'docs site',
      prependText: 'For more details, visit ',
      label: 'Hedera Network Fees Documentation'
    }
  }
};

// Helper functions
export const getServiceById = (serviceId) => {
  return hederaFeeData.services.find(service => service.id === serviceId);
};

export const getApiById = (serviceId, apiId) => {
  const service = getServiceById(serviceId);
  return service?.apis.find(api => api.id === apiId);
};

export const calculateTotalFee = (selections) => {
  return selections.reduce((total, selection) => {
    return {
      usd: total.usd + (selection.totalUSD || 0),
      hbar: total.hbar + (selection.totalHBAR || 0)
    };
  }, { usd: 0, hbar: 0 });
};

export default hederaFeeData;
